let host = "https://mymarket-api.ducklabs.com.br";

if (process.env.NODE_ENV === "development") {
  host = "http://localhost:3000";
}

export const serverHost = () => host;
